import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AdminPanel.css';

// Компоненты страниц
import FinancePage from './pages/FinancePage';
import ModerationPage from './pages/ModerationPage';
import ProfilesPage from './pages/ProfilesPage';
import ContactLogPage from './pages/ContactLogPage';
import ApiRequestsPage from './pages/ApiRequestsPage';

const AdminPanel = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  // Восстанавливаем активную вкладку из localStorage или используем 'finance' по умолчанию
  const [currentPage, setCurrentPage] = useState(() => {
    return localStorage.getItem('admin_current_page') || 'finance';
  });
  const [adminData, setAdminData] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Авторизация
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL || 'https://b.supchats.com';

  useEffect(() => {
    checkAdminAuth();
  }, []);

  // Сохраняем текущую вкладку при её изменении
  const handlePageChange = (page) => {
    setCurrentPage(page);
    localStorage.setItem('admin_current_page', page);
  };

  const checkAdminAuth = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      if (token) {
        const response = await axios.get(`${API_URL}/admin/verify`, {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true
        });
        if (response.data.ok) {
          setIsAuthenticated(true);
          setAdminData(response.data.admin);
        }
      }
    } catch (error) {
      localStorage.removeItem('admin_token');
    } finally {
      setLoading(false);
    }
  };

  const handleAdminLogin = async () => {
    if (!email || !password) {
      setMessage('Введите email и пароль');
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.post(`${API_URL}/admin/login`, {
        email,
        password
      }, {
        withCredentials: true
      });

      if (response.data.ok) {
        localStorage.setItem('admin_token', response.data.token);
        setIsAuthenticated(true);
        setAdminData(response.data.admin);
        setMessage('');
      }
    } catch (error) {
      setMessage(error.response?.data?.detail || 'Ошибка авторизации');
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    setIsAuthenticated(false);
    setAdminData(null);
    setEmail('');
    setPassword('');
  };

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="admin-spinner"></div>
        <p>Загрузка...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="admin-login-container">
        <div className="admin-login-card">
        <div className="admin-logo">
          <h1>🛡️ Админ Панель</h1>
          <p>Supchats Administration</p>
        </div>
        
        <form
          className="admin-login-form"
          onSubmit={(e) => {
            e.preventDefault();
            handleAdminLogin();
          }}
        >
          <input
            type="email"
            placeholder="Email администратора"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="admin-input"
            autoComplete="username"
          />
          <input
            type="password"
            placeholder="Пароль"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="admin-input"
            autoComplete="current-password"
          />
          
          {message && (
            <div className="admin-message error">
              {message}
            </div>
          )}
          
          <button
            type="submit"
            disabled={isLoading}
            className="admin-login-btn"
          >
            {isLoading ? 'Вход...' : 'Войти'}
          </button>
        </form>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-panel">
      <div className="admin-header">
        <div className="admin-header-content">
        <div className="admin-header-left">
            <h1 className="admin-logo-click" onClick={() => { try { window.location.href = '/'; } catch(e) {} }}>🛡️ Админ Панель</h1>
          <span className="admin-welcome">
            Добро пожаловать, {adminData?.name || adminData?.email}
          </span>
        </div>
        <button onClick={handleLogout} className="admin-logout-btn">
          Выйти
        </button>
      </div>

      <div className="admin-navigation">
        <button
          className={`admin-nav-btn ${currentPage === 'finance' ? 'active' : ''}`}
            onClick={() => handlePageChange('finance')}
        >
          💰 Финансы
        </button>
        <button
          className={`admin-nav-btn ${currentPage === 'moderation' ? 'active' : ''}`}
            onClick={() => handlePageChange('moderation')}
        >
          🚫 Модерация
        </button>
        <button
          className={`admin-nav-btn ${currentPage === 'profiles' ? 'active' : ''}`}
          onClick={() => handlePageChange('profiles')}
        >
          👥 Профили
        </button>
        <button
          className={`admin-nav-btn ${currentPage === 'contact_log' ? 'active' : ''}`}
          onClick={() => handlePageChange('contact_log')}
        >
          📬 Журнал обращений
        </button>
        <button
          className={`admin-nav-btn ${currentPage === 'api_requests' ? 'active' : ''}`}
          onClick={() => handlePageChange('api_requests')}
        >
          🔑 API заявки
        </button>
        </div>
      </div>

      <div className="admin-content">
        {currentPage === 'finance' && <FinancePage />}
        {currentPage === 'moderation' && <ModerationPage />}
        {currentPage === 'profiles' && <ProfilesPage />}
        {currentPage === 'contact_log' && <ContactLogPage />}
        {currentPage === 'api_requests' && <ApiRequestsPage />}
      </div>
    </div>
  );
};

export default AdminPanel; 